import { styled } from '@linaria/react'

export const Toolbar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  column-gap: 1rem;
  margin-bottom: 1rem;
`

export const SearchContainer = styled.div`
  width: 260px;
`
